/* ==========================================================================
   B&B – Wishlist icon state (bb-wishlist.js)
   Wishlist Hero draws its own button inside each .bb-pg__wish. We hide its
   look and show our bookmark instead, so we need to know when a product is
   saved. This watches Wishlist Hero's button and sets data-saved="true|false"
   on our wrapper, which the CSS uses to show the outline or filled icon.
   ========================================================================== */

(() => {
  if (window.bbWishlistLoaded) return;
  window.bbWishlistLoaded = true;

  const isSaved = (wrap) => {
    const btn = wrap.querySelector('.wishlist-hero-custom-button button');
    if (!btn) return false;

    // Signals Wishlist Hero uses when an item is in the wishlist
    const label = `${btn.getAttribute('aria-label') || ''} ${btn.getAttribute('title') || ''}`.toLowerCase();
    if (label.includes('remove') || label.includes('added') || label.includes('in wishlist')) return true;
    if (btn.getAttribute('aria-pressed') === 'true') return true;

    // Font Awesome: "far" = outline (not saved), "fas" = solid (saved)
    const icon = btn.querySelector('svg[data-prefix]');
    if (icon && icon.getAttribute('data-prefix') === 'fas') return true;

    return false;
  };

  const update = (wrap) => {
    const saved = String(isSaved(wrap));
    if (wrap.dataset.saved !== saved) wrap.dataset.saved = saved;
  };

  const watch = (wrap) => {
    if (wrap.dataset.bbWatched) return;
    wrap.dataset.bbWatched = 'true';
    update(wrap);
    new MutationObserver(() => update(wrap)).observe(wrap, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-label', 'title', 'aria-pressed', 'data-prefix', 'data-icon', 'class']
    });
  };

  const scan = (root) => root.querySelectorAll('.bb-pg__wish').forEach(watch);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);

  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();